module.exports = __webpack_public_path__ + "static/media/igw.575ba6c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/igw.png
// module id = 249
// module chunks = 0